<template>
    <div>
        <div class="row no-gutters d-flex justify-content-between">
            <div class="col-3 block-data-1 text-center p-4 bg-verano">
                <div>Reserva</div>
                <div class="booking-id">{{ RES.id }}</div>
                <div class="booking-plan">{{ RES.nplan }}</div>
            </div>

            <div class="col-5 block-data-2 card-body p-2">
                <div class="hotel cabe1" v-show="RES.plan==2">{{ RES.cnom }} </div>
                <div class="hotel">{{ RES.hotel }} </div>
                <div class="location"><small>{{ RES.pob }} {{ RES.pro }}</small></div>
                <div class="d-flex">
                    <div class="mr-2"><span>Entrada<br></span> {{ RES.fhe }}</div>
                    <div class="mr-2"><span>Salida<br></span> {{ RES.fhs }}</div>
                    <div class="mr-2"><span>Noc.<br></span> {{ RES.noc }} </div>
                    <div class="mr-1"><span>Reg.<br></span> {{ RES.reg }} </div>
                </div>
                <div class="mr-3" v-show="RES.plan!='2'"><span>Personas</span>{{ personas }}</div>
            </div>
            <div class="col-4 block-data-3 card-body text-right p-2">
                <div class="mb-1"><span>Total a Pagar</span>{{ RES.pag }}</div>
                <!-- <div v-show="RES.std>=0"> -->
                <div>
                    <span class="anulada" v-show="RES.std==3||RES.std==4">A N U L A D A</span>
                    <span class="finalizada" v-show="RES.bFra==1">F I N A L I Z A D A</span>

                    <b-btn variant="danger" size="sm" class="mt-1" @click="anular" v-show="RES.std<2">
                        <b-icon icon="x-circle" variant="danger"></b-icon> ANULAR
                    </b-btn>
                    <b-btn variant="secondary" size="sm" class="mt-1" @click="pdf_doc(1)" v-show="RES.std<2">
                        <b-icon icon="credit-card" variant="primary"></b-icon> Reserva / Banco
                    </b-btn>
                    <b-btn variant="secondary" size="sm" class="mt-1" @click="pdf_doc(2)" v-show="RES.std==2">
                        <b-icon icon="printer-fill" variant="primary"></b-icon> Bonos
                    </b-btn>
                    <b-btn variant="secondary" size="sm" class="mt-1" @click="pdf_doc(3)" v-show="RES.bFra==1">
                        <b-icon icon="printer-fill" variant="primary"></b-icon> Factura
                    </b-btn>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { mapState, mapMutations, mapActions } from 'vuex';

export default {
    name: 'reserva',
    props: {
        R: { type:Object, default: null},
    },

  data() {
    return {
        modulo: 'RESERVA',

    }
  },

  created() {
  },

  mounted() {

  },

  computed: {
    ...mapState(['auth','SOL','G']),

    RES() {
        let r=(this.R==null ? {} : this.R);

        //this.R.hoy=moment().format('YYYY-MM-DD');

        return r;
    },

    logueado() {
        return this.auth.logueado;
    },
    usuario() {
        return this.$store.state.auth.user;
    },

    personas() {
        let p= this.RES.adu + ' Adulto' + (this.RES.adu>1 ? 's':'') +
            (this.RES.nin>0 ? this.RES.nin + ' Niño' + (this.RES.nin>1 ? 's':'') : '');
        return p;
    },



  },

  methods: {
       ...mapMutations(['loading','alerta','modal']),
       ...mapActions(['exec']),

        /* async leemos() {
            //this.loading();
            var args={ token: this.auth.token, fnt:'get' }
            let r=await this.exec({api:'reservas', arg: args });
            //this.loading(false);

            if (r.error) {
                //mensaje error modal ... mostrar r.datos
                let m=(r.datos==''?'NO HAY RESERVAS':r.datos);
                this.modal({tit: this.modulo, msg: m});

                this.$router.push('/inicio');
                return;
            }

            //guardamos datos
            this.$store.state.EMP=r.datos[0]; //Object.values(r.datos[0]);
            this.$store.state.ASI=Object.values(r.datos[1]);
            //this.$store.state.SOL=r.datos[2];
            this.SS=r.datos[2];
            this.$store.state.SOL=this.SS;

        }, */

       async anular() {
            let msg="Estas Seguro <b>ANULAR</b> RESERVA <b>" + this.RES.id + "</b>?<br>" +
                "<br>Le comunicamos que dispone de 2 anulaciones como máximo en cada plan." +
                "<br>No podrá solicitar nueva Reserva hasta que trascurran 7 dias desde la anulación.";
            let r=await this.$root.$msgConf(msg, this.modulo);
            if (!r) return;

            this.loading();

            var args={ token: this.auth.token, fnt:'anular', id: this.RES.id }
            r=await this.exec({api:'reserva', arg: args });

            if (!r.error)
                r.datos='RESERVA ANULADA';

            this.loading(false);

            //guardamos datos
            this.modal({tit: this.modulo, msg: r.datos});

            //this.$router.push('/reservas');
            //this.leemos();

            this.$emit('actualiza');
        },

        pdf_doc0(t) {
            let tt=new Date().getTime();
            let ff=(t==3 ? 'fra1' : (t==2 ? 'res2' : 'res1' ));
            let url=this.G.urlA + ff + ".php?arg=" + tt + "|" + this.RES.id + '|9';

            window.open(url,'blank');
        },

        async pdf_doc(t) {
            var args={ token: this.auth.token, tp: t, id: this.RES.id }
            let r=await this.exec({api:'pdf_reserva', arg: args });

            if (r.error) {
                this.modal({tit: this.modulo, msg: r.datos});
                return;
            }
            let url=this.G.url_tmpW + r.datos;
            window.open(url,'blank');
        },

   }

}
</script>

<style scoped>

.anulada {
    font-size: 1.5rem;
    color: red;
    /* text-align: center; */
    font-weight: bold;
}
.finalizada {
    font-size: 1.5rem;
    color: rgb(24, 207, 42);
    /* text-align: center; */
    font-weight: bold;
}

.cabe1 {
    font-size: 1.0rem;
    color: blue;
    /* text-align: center; */
    font-weight: bold;
}
</style>